import type { StatusIndicatorProps } from '@diligentcorp/atlas-theme-mui-lens';

type CustomColor = NonNullable<StatusIndicatorProps['customColor']>;
type Tokens = Parameters<Extract<CustomColor, (...args: never) => unknown>>[0];

export type ColorResolver = (tokens: Tokens) => {
  backgroundColor: string;
  color: string;
};

// purple — used for: Speak Up Draft, Form Management Draft
export const draftColorResolver: ColorResolver = (tokens) => ({
  backgroundColor: '#db8bff', // core.color.purple[70] — not exposed in LensThemeTokens
  color: tokens.semantic.color.type.default.value,
});

// sky blue — used for: Speak Up New, COI New
export const newColorResolver: ColorResolver = (tokens) => ({
  backgroundColor: tokens.semantic.color.status.notification.default.value,
  color: tokens.semantic.color.type.default.value,
});

// teal — used for: Speak Up Read, COI Under review
export const underReviewColorResolver: ColorResolver = (tokens) => ({
  backgroundColor:
    tokens.semantic.color.dataVisualization.sequential.positive['03'].value,
  color: tokens.semantic.color.type.default.value,
});

// yellow — used for: Speak Up Investigating, COI Pending mitigation, Form Management Unpublished
export const pendingMitigationColorResolver: ColorResolver = (tokens) => ({
  backgroundColor: tokens.semantic.color.status.warning.default.value,
  color: tokens.semantic.color.type.default.value,
});

// dark red — used for: COI Overdue mitigation
export const overdueMitigationColorResolver: ColorResolver = (tokens) => ({
  backgroundColor: tokens.semantic.color.status.error.default.value,
  color: tokens.semantic.color.status.error.textDefault.value,
});

// light green (white text) — used for: Speak Up Closed, COI Closed
export const closedColorResolver: ColorResolver = (tokens) => ({
  backgroundColor: tokens.semantic.color.status.success.default.value,
  color: tokens.semantic.color.status.success.textDefault.value,
});

// light green (dark text) — used for: Form Management Published/Active
export const publishedColorResolver: ColorResolver = (tokens) => ({
  backgroundColor: tokens.semantic.color.status.success.default.value,
  color: tokens.semantic.color.type.default.value,
});

// dark teal — used for: COI Auto-closed, Form Management Archived
export const autoClosedColorResolver: ColorResolver = (tokens) => ({
  backgroundColor:
    tokens.semantic.color.dataVisualization.sequential.positive['05'].value,
  color: tokens.semantic.color.type.inverse.value,
});

// pink — used for: Speak Up / Reporter portal Pending (Lodged)
export const pendingColorResolver: ColorResolver = (tokens) => ({
  backgroundColor: '#FF99C4',
  color: tokens.semantic.color.type.default.value,
});

export const defaultColorResolver: ColorResolver = (tokens) => ({
  backgroundColor: tokens.semantic.color.status.neutral.background.value,
  color: tokens.semantic.color.status.neutral.textDefault.value,
});
